import React from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import Home from "../pages/Home";
import PdfViewer from "../pages/PDFViewer/PDFViewer";
import NotFound from "../pages/NotFound";
import PreRegistration from "../pages/safe-refund/pre-registration/PreRegistration";
import RefundVerification from "../pages/Events/RefundVerification/RefundVerification";

function AppRouter(): React.JSX.Element {
  return (
    <Router>
      <Routes>
        {/*<Route path="/" element={<Home />} />*/}
        <Route path="/certified" element={<PdfViewer />} />
        <Route path="/safe-refund/pre-registration" element={<PreRegistration />} />
        <Route path="/refund-verification" element={<RefundVerification />} />
        {/* 404 페이지 라우트 추가 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default AppRouter;